import { render, staticRenderFns } from "./navbuttons-large.vue?vue&type=template&id=767c43ca&"
import script from "./navbuttons-large.vue?vue&type=script&lang=js&"
export * from "./navbuttons-large.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('767c43ca')) {
      api.createRecord('767c43ca', component.options)
    } else {
      api.reload('767c43ca', component.options)
    }
    module.hot.accept("./navbuttons-large.vue?vue&type=template&id=767c43ca&", function () {
      api.rerender('767c43ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/nav/navbuttons-large.vue"
export default component.exports